import axios from "../../../axios";

const api = {
  getUpstreamTransportationAndDistributionItems(params, accessToken) {
    const config = {
      params: params.queryParams,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/supplier-questionnaires/${params.questionnaireId}/upstream-transportation-distribution/items`,
      config).then(({ data }) => data);
  },

  addUpstreamTransportationAndDistributionItems({ questionnaireId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.post(`/supplier-questionnaires/${questionnaireId}/upstream-transportation-distribution/items`, data, headers)
      .then(({ data }) => data);
  },

  updateUpstreamTransportationAndDistributionItem({ questionnaireId, recordId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.put(`/supplier-questionnaires/${questionnaireId}/upstream-transportation-distribution/items/${recordId}`, data, headers)
      .then(({ data }) => data);
  },

  deleteUpstreamTransportationAndDistributionItem({ questionnaireId, recordId }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.delete(`/supplier-questionnaires/${questionnaireId}/upstream-transportation-distribution/items/${recordId}`, headers)
      .then(({ data }) => data);
  },

  importUpstreamTransportationAndDistributionItems({ questionnaireId, data }, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.post(`/supplier-questionnaires/${questionnaireId}/upstream-transportation-distribution/items/import`, data, headers).then(({ data }) => data);
  },

  getUpstreamTransportationAndDistributionPreviewData({ previewId, params }, accessToken) {
    const config = {
      params,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/supplier-questionnaires/preview/${previewId}/upstream-transportation-distribution/items`, config).then(({ data }) => data);
  },
};

export default api;